export default __webpack_public_path__ + "static/media/Average Grassed.05d82a68.png";